import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { setSimParam, getSimParam } from "./utils.js";

import Card from "react-bootstrap/Card";
import ProgressBar from "react-bootstrap/ProgressBar";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";

import CardTitle from "./CardTitle.js";
import ButtonGrid from "./ButtonGrid.js";
import Dialog from "./Dialog.js";
import CallButton from "./CallButton.js";
import GroupTitle from "./GroupTitle.js";
import GroupTitles from "./GroupTitles.js";
//import DatetimeTitle from "./DatetimeTitle.js";
import ArticleCard from "./ArticleCard.js";

const withCallButtons = false;

export default function AmendmentCard (props)
{
    const gData = useData();

    if (props.amendmentID === null && props.amendment === null) return (<></>);

    const amendment = props.amendmentID !== null ? gData.amendment[props.amendmentID] : props.amendment;
    let amendmentState = amendment.state;
    if (amendment.state === "canceled" || (amendment.state !== "accepted" && amendment.state !== "rejected" && amendment.sessionNum !== gData.sim[gData.simID].sessionNum)) amendmentState = "archived";

    // CLASSES
    let amendmentCardClassNames = "";
    switch (amendmentState)
    {
	case "draft" :     amendmentCardClassNames = "border-secondary"; break;
	case "waiting" :   amendmentCardClassNames = "border-secondary"; break;
	case "submitted" : amendmentCardClassNames = "border-dark";      break;
	case "accepted" :  amendmentCardClassNames = "border-success";   break;
	case "rejected" :  amendmentCardClassNames = "border-danger";    break;
	case "archived" :  amendmentCardClassNames = "border-secondary"; break;
	case "deleted" :   amendmentCardClassNames = "border-secondary"; break;
	default :          amendmentCardClassNames = "border-warning";
    }

    return (
	<Card className={"shadow-sm w-100 border-2 " + amendmentCardClassNames}>
	    <AmendmentCard.Header amendment={amendment}/>
	    <AmendmentCard.Body amendment={amendment} present={props.present}/>
	    {props.footer && (<AmendmentCard.Footer amendment={amendment}/>)}
	</Card>
    );
}

AmendmentCard.defaultProps = {
    amendmentID: null,
    amendment: null,
    footer: true,
    present: false
};


AmendmentCard.Header = function Header (props)
{
    const gData = useData();

    const amendment = props.amendment;
    const amendmentType = amendment.type;
    const amendmentSessionNum = amendment.sessionNum;

    let amendmentState = amendment.state;
    if (amendment.state === "canceled" || (amendment.state !== "accepted" && amendment.state !== "rejected" && amendment.sessionNum !== gData.sim[gData.simID].sessionNum)) amendmentState = "archived";

    let subtitle = "";
    let session = "Session " + amendmentSessionNum;
    let classNames = "";

    const element = amendmentType === "editArticle" ? "Amendement" : "Article";

    switch (amendmentState)
    {
	case "draft" :     subtitle = element + " rédigé (brouillon)";  classNames = "bg-secondary"; break; 
	case "waiting" :   subtitle = element + " déposé (validation en cours)"; classNames = "bg-secondary"; break; 
	case "submitted" : subtitle = element + " déposé";              classNames = "bg-dark";      break; 
	case "accepted" :  subtitle = element + " adopté";              classNames = "bg-success";   break; 
	case "rejected" :  subtitle = element + " rejeté";              classNames = "bg-danger";    break;
	case "archived" :  subtitle = element + " archivé";             classNames = "bg-secondary"; break; 
	case "deleted" :   subtitle = element + " supprimé";            classNames = "bg-secondary"; break;
	default :          subtitle = element + " (état inconnu)";      classNames = "bg-warning";
    }

    return (
	<Card.Header className={classNames + " d-flex justify-content-between"}>
	    <CardTitle subtitle={subtitle} light/>
	    <CardTitle subtitle={session} light/>
	</Card.Header>
    );
}


AmendmentCard.Body = function Body (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const sessionNum = gData.sim[gData.simID].sessionNum;
    const sessionStep = getSimParam(gData, "sessionStep");

    const amendment = props.amendment;

    const groupID = amendment.groupID;
    
    const amendmentID = amendment.amendmentID;
    //const amendmentCreationTime = amendment.creationTime;
    const amendmentSupportIDS = amendment.supportIDS;

    const amendmentSessionNum = amendment.sessionNum;
    const amendmentType = amendment.type;
    let amendmentState = amendment.state;
    if (amendment.state === "canceled" || (amendment.state !== "accepted" && amendment.state !== "rejected" && amendmentSessionNum !== sessionNum)) amendmentState = "archived";

    const articleID = amendment.articleID;
    const article = articleID !== null ? gData.article[articleID] : { articleID: null, firstArticleID: null, prevArticleID: null, type: "article", content: [""] };
    
    const prevArticleID = amendment.prevArticleID;
    const prevArticle = prevArticleID !== null ? gData.article[prevArticleID] : { articleID: null, content: [""] };

    const element = amendmentType === "editArticle" ? "Amendement" : "Article";

    const amendmentPossible = article.content.every((articleParagraph, index) => {
	const prevArticleParagraph = index < prevArticle.content.length ? prevArticle.content[index] : "";
	const amendmentParagraph = index < amendment.content.length ? amendment.content[index] : "";
	return amendmentParagraph === prevArticleParagraph || articleParagraph === prevArticleParagraph || amendmentParagraph === articleParagraph;
    });

    let presentAmendmentState = null;
    if (props.present && getSimParam(gData, "presentAmendment") && getSimParam(gData, "presentAmendmentID") === amendmentID)
	presentAmendmentState = getSimParam(gData, "presentAmendmentState");

    // VOTES
    const voteStateOngoing = amendmentState === "submitted" && presentAmendmentState === "vote";
    const voteStateResults = (amendmentState === "submitted" && presentAmendmentState === "result") || (amendmentState === "accepted" || amendmentState === "rejected");

    const votes = Object
	.entries(gData.vote)
	.filter(([id, vote]) => { return vote.amendmentID === amendmentID; })
	.map(([id, vote]) => vote);

    const voteMyIDS = votes.filter((vote) => { return vote.groupID === gData.groupID; });
    const voteMyID = voteMyIDS.length > 0 ? voteMyIDS[0].voteID : null;
    const voteMyValue = voteMyID !== null ? gData.vote[voteMyID].value : null;
    const voteMyCount = gData.group[gData.groupID].voteCount;

    const voteCountList = votes.reduce((counts, vote) => { counts[vote.value] += vote.count; return counts; }, { "-1": 0, "0": 0, "1": 0 });
    const voteCount = voteCountList["-1"] + voteCountList["0"] + voteCountList["1"];

    const voteGroupIDList = votes.reduce((groupIDS, vote) => { groupIDS[vote.value].push(vote.groupID); return groupIDS; }, { "-1": [], "0": [], "1": [] });
    const voteGroupIDS = votes.reduce((groupAllIDS, vote) => { groupAllIDS.push(vote.groupID); return groupAllIDS; }, []);

    const voteGroupWaitIDS = Object
	.entries(gData.group)
	.filter(([id, group]) => { return group.simID === gData.simID && group.selected === 1 && group.type === "delegation" && ! voteGroupIDS.includes(group.groupID); })
	.map(([id, group]) => group.groupID);
    const voteWaitCount = voteGroupWaitIDS.reduce((count, groupID) => { return count + gData.group[groupID].voteCount; }, 0);
    const voteAllCount = voteCount + voteWaitCount;

    // STATE STRING    
    let stateStr = null;
    if (amendmentState === "draft") stateStr = (<span className="fw-medium">Rédaction en cours</span>);
    else if (amendmentState === "waiting") stateStr = (<span className="fw-medium">Validation en cours</span>);
    else if (amendmentState === "archived")
    {
	if (amendment.state === "draft") stateStr = (<span className="fw-medium">{element} non-déposé</span>);
	else if (amendment.state === "waiting") stateStr = (<span className="fw-medium">{element} non-validé</span>);
	else if (amendment.state === "submitted") stateStr = (<span className="fw-medium">{element} non-voté</span>);
	else if (amendment.state === "canceled") stateStr = (<span className="fw-medium">{element} non-voté</span>);
    }
    else if (amendmentState === "submitted" && ! amendmentPossible) stateStr = (<span className="fw-medium">Amendement caduc</span>);
    else if (amendmentState === "submitted" && presentAmendmentState === null) stateStr = (<span className="fw-medium">En attente de présentation</span>);
    else if (amendmentState === "submitted" && presentAmendmentState === "present") stateStr = (<span className="fw-medium">Présentation en cours</span>);
    else if (voteStateOngoing) stateStr = (<span className="fw-medium">Vote en cours</span>);
    else if (voteStateResults) stateStr = (<span className="fw-medium">Vote terminé</span>);

    
    // GROUP INFO
    const groupInfo = (
	<div className="d-flex align-items-center">
	    <div className="flex-shrink-0" style={{ width: 140 }}>Rédigé par</div>
	    <GroupTitle groupID={groupID} determiner={true}/>
	    <div className="ms-auto">{stateStr}</div>
	</div>
    );


    // CREATION TIME INFO
    //const creationTimeInfo = (<DatetimeTitle time={amendmentCreationTime}/>);

    // SUPPORT INFO
    let supportButton = (<></>);
    const groupType = gData.groupID !== null && gData.group[gData.groupID] !== undefined ? gData.group[gData.groupID].type : null;
    if (sessionStep === "write" && amendmentState === "submitted" && amendmentSessionNum === sessionNum && groupID !== gData.groupID && (groupType === "delegation" || groupType === "lobby"))
    {
	const support = amendmentSupportIDS.includes(gData.groupID);

	function handleToggleSupport ()
	{
	    const newSupportIDS = support ? amendmentSupportIDS.filter((id) => id !== gData.groupID) : [...amendmentSupportIDS, gData.groupID];
	    gDispatch({ type: "upload", table: "amendment", id: amendmentID, data: { supportIDS: newSupportIDS } });
	}

	supportButton = (<ToggleButton type="radio" size="md" variant="outline-primary" checked={support} onClick={handleToggleSupport}>{support ? "Soutenu" : "Soutenir"}</ToggleButton>);
    }
    
    let supportInfo = (
	<div className="d-flex align-items-start">
	    <div className="flex-shrink-0" style={{ width: 140 }}>Soutenu par</div>
	    {amendmentSupportIDS.length > 0 && (<GroupTitles groupIDS={amendmentSupportIDS}/>)}
	    {amendmentSupportIDS.length === 0 && (<div className="fst-italic">(aucun soutien)</div>)}
	    <div className="ms-auto">{supportButton}</div>
	</div>
    );

    // VOTE BAR
    let voteBar = (<></>);
    
    if (voteStateOngoing)
    {
	voteBar = (<ProgressBar animated variant="secondary" now={100*voteCount/voteAllCount}/>);
    }

    else if (voteStateResults)
    {
	voteBar = (
	    <ProgressBar>
		<ProgressBar variant="success" key={1} now={100 * voteCountList["1"] / voteCount}/>
		<ProgressBar variant="danger" key={2} now={100 * voteCountList["-1"] / voteCount}/>
		<ProgressBar variant="warning" className="opacity-50" key={3} now={100 * voteCountList["0"] / voteCount}/>
	    </ProgressBar>
	);
    }

    // VOTE RESULTS
    let voteResults = (<></>);
    if (voteStateOngoing && gData.admin)
    {
	voteResults = (
	    <>
		{voteGroupIDS.length > 0 && (
		    <div className="d-flex align-items-center">
			<div className="flex-shrink-0 text-uppercase fw-medium" style={{ width: 140 }}>{voteCount} exprimé{voteCount > 1 ? "s" : ""}</div>
			<GroupTitles variant="outline-dark" groupIDS={voteGroupIDS} voteCount={true} simple={true}/>
		    </div>
		)}
		{voteGroupWaitIDS.length > 0 && (
		    <div className="d-flex align-items-center">
			<div className="flex-shrink-0 text-uppercase text-secondary fw-medium" style={{ width: 140 }}>{voteWaitCount} en attente</div>
			<GroupTitles variant="outline-secondary" groupIDS={voteGroupWaitIDS} voteCount={true} simple={true}/>
		    </div>
		)}
	    </>
	);
    }
    
    else if (voteStateResults)
    {
	voteResults = (
	    <>
		{voteCountList["1"] > 0 && (
		    <div className="d-flex align-items-center">
			<div className="flex-shrink-0 text-start text-uppercase text-success fw-medium" style={{ width: 140 }}>{voteCountList["1"]} pour</div>
			<GroupTitles variant="outline-success" groupIDS={voteGroupIDList["1"]} voteCount={true} simple={true}/>
		    </div>
		)}
		{voteCountList["-1"] > 0 && (
		    <div className="d-flex align-items-center">
			<div className="flex-shrink-0 text-start text-uppercase text-danger fw-medium" style={{ width: 140 }}>{voteCountList["-1"]} contre</div>
			<GroupTitles variant="outline-danger" groupIDS={voteGroupIDList["-1"]} voteCount={true} simple={true}/>
		    </div>
		)}
		{voteCountList["0"] > 0 && (
		    <div className="d-flex align-items-center">
			<div className="flex-shrink-0 text-start text-uppercase text-warning fw-medium" style={{ width: 140 }}>{voteCountList["0"]} abs.</div>
			<GroupTitles variant="outline-warning" groupIDS={voteGroupIDList["0"]} voteCount={true} simple={true}/>
		    </div>
		)}
	    </>
	);
    }
    
    // VOTE BUTTONS
    function setVoteValue (value)
    {
	gDispatch({ type: "upload", table: "vote", id: voteMyID, data: { simID: gData.simID, groupID: gData.groupID, amendmentID: amendmentID, value, count: voteMyCount } });
    }
    
    function handleVoteProAmendment () { setVoteValue(1); }
    function handleVoteConAmendment () { setVoteValue(-1); }
    function handleVoteAbsAmendment () { setVoteValue(0); }

    let voteButtons = (<></>);
    if (voteStateOngoing && gData.group[gData.groupID].type === "delegation")
    {
	voteButtons = (
	    <div className="d-flex justify-content-center gap-2">
		<ButtonGroup>
		    <ToggleButton type="radio" variant="outline-success" className="text-uppercase" value={1} checked={voteMyValue === 1} onClick={handleVoteProAmendment}>Pour</ToggleButton>
		    <ToggleButton type="radio" variant="outline-secondary" className="text-uppercase" value={0} checked={voteMyValue === 0} onClick={handleVoteAbsAmendment}>Abstention</ToggleButton>
		    <ToggleButton type="radio" variant="outline-danger" className="text-uppercase" value={-1} checked={voteMyValue === -1} onClick={handleVoteConAmendment}>Contre</ToggleButton>
		</ButtonGroup>
	    </div>
	);
    }


    // STATE INFO
    let voteInfo = (<></>);
    if (voteStateOngoing || voteStateResults)
    {
	voteInfo = (
	    <>
		<Card.Header className="d-flex align-items-center gap-3">
		    {voteStateOngoing && (<CardTitle subtitle="Vote en cours"/>)}
		    {voteStateResults && (<CardTitle subtitle="Résultats du vote"/>)}
		    <div className="flex-fill">{voteBar}</div>
		</Card.Header>
		<Card.Body className="d-flex flex-column gap-1">
		    {voteResults}
		    {voteButtons}
		</Card.Body>
	    </>
	);
	
	/* voteInfo = (
	   <div>
	   <div className="d-flex align-items-center gap-4">
	   {voteStateOngoing && (<div>Vote en cours</div>)}
	   {voteStateResults && (<div>Résultats du vote</div>)}
	   <div className="flex-fill">{voteBar}</div>
	   </div>
	   {voteResults}
	   </div>
	   ); */
    }

    
    // RENDER    
    return (
	<>
	    <Card.Body className="d-flex flex-column gap-1">
		{groupInfo}
		{supportInfo}
	    </Card.Body>
	    <ArticleCard.Header article={article}/>
	    <ArticleCard.Body article={article} amendment={amendment} prevArticle={prevArticle} present={props.present}/>
	    {voteInfo}
	</>
    );
}

AmendmentCard.Body.defaultProps = {
    present: false
};




AmendmentCard.Footer = function Footer (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const amendment = props.amendment;
    const amendmentID = amendment.amendmentID;
    const amendmentGroupID = amendment.groupID;

    let amendmentState = amendment.state;
    if (amendment.state !== "accepted" && amendment.state !== "rejected" && amendment.sessionNum !== gData.sim[gData.simID].sessionNum) amendmentState = "archived";

    const articleID = amendment.articleID;
    const article = articleID !== null ? gData.article[articleID] : { content: [""] };
    
    const prevArticleID = amendment.prevArticleID;
    const prevArticle = prevArticleID !== null ? gData.article[prevArticleID] : { content: [""] };

    const amendmentPossible = article === null || prevArticle === null || article.content.every((articleParagraph, index) => {
	const prevArticleParagraph = index < prevArticle.content.length ? prevArticle.content[index] : "";
	const amendmentParagraph = index < amendment.content.length ? amendment.content[index] : "";
	return amendmentParagraph === prevArticleParagraph || articleParagraph === prevArticleParagraph || amendmentParagraph === articleParagraph;
    });

    const sessionStep = getSimParam(gData, "sessionStep");

    // ACTIONS
    function handleEditAmendment () { gDispatch({ type: "showEditAmendment", amendmentID }); }
    function handlePresentAmendment () { setSimParam(gData, gDispatch, ["presentAmendment", "presentAmendmentID", "presentAmendmentState"], [true, amendmentID, "present"]); }

    function handleDeletedAmendment () { gDispatch({ type: "upload", table: "amendment", id: amendmentID, data: { state: "deleted" } }); }
    function handleDraftAmendment () { gDispatch({ type: "upload", table: "amendment", id: amendmentID, data: { state: "draft" } }); }
    function handleWaitingAmendment () { gDispatch({ type: "upload", table: "amendment", id: amendmentID, data: { state: "waiting" } }); }
    function handleSubmittedAmendment () { gDispatch({ type: "upload", table: "amendment", id: amendmentID, data: { state: "submitted" } }); }
    function handleCanceledAmendment () { gDispatch({ type: "upload", table: "amendment", id: amendmentID, data: { state: "canceled" } }); }
    
    // DELETE CONFIRM DIALOG
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    function showDeleteConfirm () { setDeleteConfirm(true); }
    function hideDeleteConfirm () { setDeleteConfirm(false); }

    const deleteConfirmDialog = (
	<Dialog show={deleteConfirm} hide={hideDeleteConfirm} confirm={handleDeletedAmendment} title="Supprimer cet amendement">
	    <p>Attention : cet amendement sera supprimé définitivement.</p>
	</Dialog>
    );

    // CANCEL CONFIRM DIALOG
    const [cancelConfirm, setCancelConfirm] = useState(false);
    function showCancelConfirm () { setCancelConfirm(true); }
    function hideCancelConfirm () { setCancelConfirm(false); }

    const cancelConfirmDialog = (
	<Dialog show={cancelConfirm} hide={hideCancelConfirm} confirm={handleCanceledAmendment} title="Ne pas voter cet amendement">
	    <p>Attention : cet amendement sera archivé sans être présenté, ni soumis au vote.</p>
	</Dialog>
    );

    // BUTTONS
    const leftButtonList = [];
    const rightButtonList = [];

    if (amendmentState !== "archived")
    {
	if (amendmentGroupID === gData.groupID && sessionStep === "write")
	{
	    if (amendmentState === "draft")
	    {
		leftButtonList.push(<Button key="editAmendment" variant="outline-secondary" size="md" onClick={handleEditAmendment}>Modifier</Button>);
		leftButtonList.push(<Button key="deletedAmendment" variant="outline-secondary" size="md" onClick={showDeleteConfirm}>Supprimer</Button>);
		rightButtonList.push(<Button key="waitingAmendment" variant="primary" size="md" onClick={handleWaitingAmendment}>Déposer</Button>);
	    }
	    
	    else if (amendmentState === "waiting")
	    {
		leftButtonList.push(<Button key="draftAmendment" variant="outline-secondary" size="md" onClick={handleDraftAmendment}>Annuler le dépôt</Button>);
	    }
	}
	
	else if (gData.groupID !== null && gData.admin)
	{
	    if ((amendmentState === "waiting" && sessionStep === "write") || amendmentState === "submitted")
	    {
		leftButtonList.push(<Button key="editAmendment" variant="outline-secondary" size="md" onClick={handleEditAmendment}>Modifier</Button>);
		//leftButtonList.push(<Button key="deletedAmendment" variant="outline-secondary" size="md" onClick={showDeleteConfirm}>Supprimer</Button>);
	    }
	    
	    if (amendmentState === "waiting" && sessionStep === "write")
	    {
		rightButtonList.push(<Button key="draftAmendment" variant="primary" size="md" onClick={handleDraftAmendment}>Refuser le dépôt</Button>);
		rightButtonList.push(<Button key="submittedAmendment" variant="primary" size="md" onClick={handleSubmittedAmendment}>Valider le dépôt</Button>);
		if (withCallButtons) leftButtonList.push(<CallButton key="pause" groupID={amendmentGroupID}/>);
	    }
	    
	    if (amendment.state === "submitted" && sessionStep !== "present")
	    {
		leftButtonList.push(<Button key="draftAmendment" variant="outline-secondary" size="md" onClick={handleDraftAmendment}>Annuler le dépôt</Button>);
	    }

	    if (amendment.state === "submitted" && sessionStep === "present")
	    {
		if (amendmentPossible)
		{
		    rightButtonList.push(<Button key="cancelAmendment" variant="primary" size="md" onClick={showCancelConfirm}>Ne pas voter</Button>)
		    rightButtonList.push(<Button key="presentAmendment" variant="primary" size="md" onClick={handlePresentAmendment}>Lancer la présentation</Button>);
		} else {
		    rightButtonList.push(<Button key="cancelAmendment" variant="primary" size="md" onClick={handleCanceledAmendment}>Ne pas voter</Button>)
		}
	    }
	}
    }

    // RENDER
    if (leftButtonList.length === 0 && rightButtonList.length === 0) return (<></>)
    else {
	return (
	    <>
		<Card.Footer>
		    <ButtonGrid>
			<ButtonGrid.Left>{leftButtonList}</ButtonGrid.Left>
			<ButtonGrid.Right>{rightButtonList}</ButtonGrid.Right>
		    </ButtonGrid>
		</Card.Footer>
		{deleteConfirmDialog}
		{cancelConfirmDialog}
	    </>
	);
    }
}




